import { DATE_RANGE_OPTIONS } from '@/helpers/reportDateRanges'

export const DEFAULT_REVENUE_RANGE = '12m'

const PRESETS = DATE_RANGE_OPTIONS.map(option => option.value)
const YMD = /^\d{4}-\d{2}-\d{2}$/

const isPreset = value => typeof value === 'string' && PRESETS.includes(value)
const isYmd = value => typeof value === 'string' && YMD.test(value)
const atLocalNoon = date => new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12)

const fromYmd = ymd => {
  const [year, month, day] = ymd.split('-').map(Number)
  return new Date(year, month - 1, day, 12)
}

export function normalizeRangeValue(value) {
  if (typeof value === 'string') return value
  return { start: atLocalNoon(new Date(value.start)), end: atLocalNoon(new Date(value.end)) }
}

export function revenueRangeQuery({ preset, apiRange }) {
  if (isPreset(preset)) return { range: preset }
  return { from: apiRange.beginning_date, to: apiRange.ending_date }
}

export function rangeFromQuery(query = {}) {
  if (isPreset(query.range)) return query.range
  if (isYmd(query.from) && isYmd(query.to)) {
    const start = fromYmd(query.from)
    const end = fromYmd(query.to)
    if (!isNaN(start.getTime()) && !isNaN(end.getTime()) && start <= end) return { start, end }
  }
  return DEFAULT_REVENUE_RANGE
}
